import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import './debughelper.css';
import Package from '../../../package.json';

export const DebugHelper = () => {
    const user = useSelector(state => state.user.user);
    const [show, setShow] = React.useState(false);
    const outer = React.useRef();

    const canViewDebugInfo = user?.authority === 'PARTNER' || user?.authority === 'SPOOF';

    if (!canViewDebugInfo) {
        return null;
    }

    const handleKeyPress = useCallback(event => {
        if (event.altKey && event.key === 'i') {
            setShow(true);
        }
    }, []);

    useEffect(() => {
        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);

        // remove the event listener
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);

    React.useEffect(() => {
        const handleClick = e => {
            if (!outer.current?.contains(e.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClick, false);

        return () => {
            document.removeEventListener('mousedown', handleClick, false);
        };
    }, []);

    const debugInfo = [];

    debugInfo.push({ key: 'user-fullname', value: user.full_Name });
    debugInfo.push({ key: 'user-id', value: user.id });
    debugInfo.push({ key: 'user-posthogid', value: user.unique_Id });
    debugInfo.push({ key: 'user-language', value: user.language_Code });
    debugInfo.push({ key: 'user-authority', value: user.authority });
    debugInfo.push({ key: 'company-name', value: user.companySettings.name });
    debugInfo.push({ key: 'company-id', value: user.company_Id });
    debugInfo.push({ key: 'IsLearn2', value: user?.companySettings?.isLearn2?.toString() });
    debugInfo.push({ key: 'current-url', value: window.location.href });
    debugInfo.push({ key: 'app-version', value: Package.version });
    debugInfo.push({ key: 'browser', value: navigator.userAgent });
    debugInfo.push({ key: 'viewport-size', value: `${window.innerWidth}x${window.innerHeight}` });
    debugInfo.push({ key: 'timestamp', value: new Date().toISOString() });
    debugInfo.push({ key: 'time zone', value: Intl.DateTimeFormat().resolvedOptions().timeZone });

    /**
     * Allow other components to add debug info by dispatching a custom event.
     * Usage: window.dispatchEvent(new CustomEvent('addDebugInfo', { detail: { key: 'foo', value: 'bar' } }))
     */
    const [externalDebugInfo, setExternalDebugInfo] = React.useState([]);

    useEffect(() => {
        const handler = e => {
            setExternalDebugInfo(prev => prev.filter(item => item.key !== e.detail.key));

            if (e.detail.value && e.detail.value.trim().length) {
                setExternalDebugInfo(prev => [...prev, e.detail]);
            }
        };
        window.addEventListener('addDebugInfo', handler);
        return () => window.removeEventListener('addDebugInfo', handler);
    }, []);

    return (
        <div className="aside-debug-info" ref={outer}>
            {show && (
                <div className="debug-info-open">
                    <h3>User Debug Info</h3>
                    <ul>
                        {debugInfo.map(info => (
                            <li key={info.key}>
                                <strong>{info.key}:</strong> {info.value}
                            </li>
                        ))}
                    </ul>
                    {externalDebugInfo.length > 0 && (
                        <>
                            <h3>Component Debug Info</h3>
                            <ul>
                                {externalDebugInfo.map(info => (
                                    <li key={`external-${info.key}`}>
                                        <strong>{info.key}:</strong> {info.value}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default DebugHelper;
